import { Injectable } from '@angular/core';
import { UserModel } from './model/user.model';
import { RequestData } from 'src/app/common/models/request-data.model';
 import { Observable } from 'rxjs';
 import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  constructor(private http: HttpClient) { }
    
      getList(requestData:RequestData): Observable<any> {
        return this.http.post(environment.baseUrl+'/user/get', requestData);
    
      }
    
      /**
       * 
       * @param userGroup id
       * Calls the API to get a specified user group
       */
      getById(id:number): Observable<any> {
        return this.http.post(environment.baseUrl+'/user/get/'+id, '');
    
      }
      
       /**
       * 
       * @param userGroup
       * Calls the update API to insert/update the record
       */
        update(userGroup: UserModel): Observable<any> { 
        if(userGroup.hasOwnProperty("id")){
          return this.http.post(environment.baseUrl+'/user/update', userGroup);
        } else{
          return this.http.post(environment.baseUrl+'/user/add', userGroup);
        }
      }
    
    
        /**
       * 
       * @param userGroup
       * Calls the API to delete the record
       */
        delete(userGroup: UserModel): Observable<any>  {
          return this.http.post(environment.baseUrl+'/user/delete/'+userGroup.id, userGroup);
        }
        
        getShopUserMapping(userId: number): Observable<any> {
          return this.http.get(`${environment.baseUrl}/user/shop-user-mapping/${userId}`);
        }
}
